import { eventResultsHistoryMapper } from "@utils/offer/mappers/EventResultsHistoryMapper";
import { ResultsHistoriesApiService } from "@api-services/offer/ResultsHistoriesApiService";
import { TOfferRequest } from "@gp/hub";
import { tournamentGroupingResultsHistoryMapper } from "@utils/offer/mappers/TournamentGroupingResultsHistoryMapper";
import {
	MenuResponse,
	PrematchMenuApiFilter,
} from "@api-types/offer/PrematchMenuResponse";
import { IOfferService } from "../IOfferService";
import { EventResultHistoryResponse } from "@api-types/offer/offer-history/EventResultHistoryResponse";
import { TournamentGroupingResultsHistoryResponse } from "@api-types/offer/offer-history/TournamentGroupingResultsHistoryResponse";

class OfferHistoryService implements IOfferService {
	public async getEventData(filter: TOfferRequest) {
		const offer =
			await ResultsHistoriesApiService.getOffer<EventResultHistoryResponse>(
				filter
			);
		const data = eventResultsHistoryMapper(offer);
		return data;
	}
	public async getOfferData(filter: TOfferRequest) {
		const offer =
			await ResultsHistoriesApiService.getOffer<TournamentGroupingResultsHistoryResponse>(
				filter
			);

		const data = tournamentGroupingResultsHistoryMapper(offer);

		return data;
	}
	public async getOfferMenu<K extends PrematchMenuApiFilter>(
		filter: K
	): Promise<MenuResponse<K>> {
		const menu = await ResultsHistoriesApiService.getMenu(filter as any);
		return menu as MenuResponse<K>;
	}
}
export const offerHistoryService = new OfferHistoryService();
